export default {
  to: "pia@copernicomi.com"
};